import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { Switch } from 'react-native-paper';
export const LabeledSwitch = ({ testID = 'labeled-switch', style = {}, right, left, ...rest }) => {
    return (_jsxs(View, { testID: `${testID}-container`, style: [{ flexDirection: 'row', alignItems: 'center' }, style], children: [left, _jsx(Switch, { testID: testID, value: rest.value, onValueChange: rest.onValueChanged, disabled: rest.disabled, color: rest.color }), right] }));
};
